import {
  boolean,
  integer,
  jsonb,
  pgEnum,
  pgTable,
  text,
} from "drizzle-orm/pg-core";
import { createSelectSchema } from "drizzle-zod";
import type z from "zod";

import { timestamps } from "./shared";

export const settingsTypeEnum = pgEnum("settings_type", [
  "string",
  "money",
  "float",
  "int",
  "boolean",
]);

export const settingsTypeSchema = createSelectSchema(settingsTypeEnum);

export type SettingsType = z.infer<typeof settingsTypeSchema>;

export const settings = pgTable("settings", {
  key: text().primaryKey(),
  label: text().notNull(),
  value: jsonb().$type<string | number | boolean>(),
  type: settingsTypeEnum().notNull(),
  order: integer(),
  hidden: boolean(),
  ...timestamps,
});

export const settingSchema = createSelectSchema(settings);

export type Setting = z.infer<typeof settingSchema>;
